import { render, staticRenderFns } from "./DevBpbjInfoModal.vue?vue&type=template&id=67f5afe5&"
import script from "./DevBpbjInfoModal.vue?vue&type=script&lang=js&"
export * from "./DevBpbjInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports